var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { JsonExclude } from '@decahedron/entity/dist/src/support/JsonExclude';
import moment from 'moment';
import { orderBy } from 'lodash';
import { PipelineStage } from 'packages/v3/pipeline/PipelineStage';
import { Campaign } from 'packages/target/entities/Campaign';
import { JobAttachedAttribute } from 'packages/talent/entities/JobAttachedAttribute';
import { v4 as uuid } from 'uuid';
export var JobCampaignStatus;
(function (JobCampaignStatus) {
    JobCampaignStatus["SCHEDULED"] = "scheduled";
    JobCampaignStatus["ACTIVE"] = "active";
    JobCampaignStatus["EXPIRED"] = "expired";
})(JobCampaignStatus || (JobCampaignStatus = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["DRAFT"] = "draft";
    JobStatus["OPEN"] = "open";
    JobStatus["PROCESSING"] = "processing";
    JobStatus["COMPLETED"] = "completed";
})(JobStatus || (JobStatus = {}));
var Job = /** @class */ (function (_super) {
    __extends(Job, _super);
    function Job() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeFrom = null;
        _this.activeTo = null;
        _this.archivedAt = null;
        _this.attributes = [];
        _this.campaigns = [];
        _this.companyId = null;
        _this.description = null;
        _this.email = null;
        _this.emailType = null;
        _this.externalApplyLink = null;
        _this.firstHiredAt = null;
        _this.formId = null;
        _this.id = null;
        _this.isHidden = true;
        _this.location = null;
        _this.mailTemplateId = null;
        _this.name = null;
        _this.stages = null;
        _this.status = null;
        _this.version = 1;
        return _this;
    }
    Object.defineProperty(Job.prototype, "activeFromDate", {
        get: function () {
            return moment(this.activeFrom);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Job.prototype, "activeToDate", {
        get: function () {
            return moment(this.activeTo);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Job.prototype, "isArchived", {
        get: function () {
            return this.archivedAt !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Job.prototype, "hasCampaign", {
        get: function () {
            return this.campaigns.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Job.prototype, "hasActiveCampaign", {
        get: function () {
            return !!this.campaigns.find(function (campaign) { return campaign.isActive; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Job.prototype, "hasScheduledCampaign", {
        get: function () {
            return !!this.campaigns.find(function (campaign) { return campaign.isScheduled; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Job.prototype, "lastOfCampaigns", {
        get: function () {
            var _a;
            if (!this.hasCampaign) {
                return null;
            }
            return (_a = orderBy(this.campaigns, ['startsAt'], ['desc'])) === null || _a === void 0 ? void 0 : _a[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Job.prototype, "campaignStatus", {
        get: function () {
            if (!this.hasCampaign) {
                return null;
            }
            else if (this.hasScheduledCampaign) {
                return JobCampaignStatus.SCHEDULED;
            }
            else if (this.hasActiveCampaign) {
                return JobCampaignStatus.ACTIVE;
            }
            return JobCampaignStatus.EXPIRED;
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Job.prototype.toJson = function (toSnake) {
        if (toSnake === void 0) { toSnake = true; }
        var json = _super.prototype.toJson.call(this, toSnake, false);
        json.active_from = moment(this.activeFrom).startOf('day').format();
        json.active_to = (this.activeTo) ? moment(this.activeTo).endOf('day').format() : null;
        return json;
    };
    Job.prototype.getStageAtPosition = function (position) {
        return this.stages.find(function (stage) { return stage.position === position; });
    };
    Job.prototype.addOrUpdateCampaign = function (campaign) {
        var foundIndex = this.campaigns.findIndex(function (listedCampaign) { return listedCampaign.id === campaign.id; });
        if (foundIndex) {
            this.campaigns.splice(foundIndex, 1, campaign);
        }
        else {
            this.campaigns.push(campaign);
        }
    };
    __decorate([
        Type(JobAttachedAttribute),
        __metadata("design:type", Array)
    ], Job.prototype, "attributes", void 0);
    __decorate([
        JsonExclude(),
        Type(Campaign),
        __metadata("design:type", Array)
    ], Job.prototype, "campaigns", void 0);
    __decorate([
        Type(PipelineStage),
        __metadata("design:type", Array)
    ], Job.prototype, "stages", void 0);
    return Job;
}(Entity));
export { Job };
export function getDefaultStages(i18n) {
    return EntityBuilder.buildMany(PipelineStage, [
        {
            id: uuid(),
            name: i18n.t('ats.pipeline.new'),
            type: 'entry',
            position: 0,
        },
        {
            id: uuid(),
            name: i18n.t('ats.pipeline.to_be_called'),
            type: 'call',
            position: 1,
        },
        {
            id: uuid(),
            name: i18n.t('ats.pipeline.called'),
            type: 'review',
            position: 2,
        },
        {
            id: uuid(),
            name: i18n.t('ats.pipeline.short_meeting'),
            type: 'interview',
            position: 3,
        },
        {
            id: uuid(),
            name: i18n.t('ats.pipeline.meeting'),
            type: 'interview',
            position: 4,
        },
        {
            id: uuid(),
            name: i18n.t('ats.pipeline.hire'),
            type: 'hire',
            position: 5,
        },
        {
            id: uuid(),
            name: i18n.t('ats.pipeline.reject'),
            type: 'rejection',
            position: 6,
        },
    ]);
}
